







import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { StringFilter, StringFilterParameter } from "../../../../base/components/system/filters";
import { EditableFormatSummaryDirectoryFilterParameter } from ".";

@Component({
  components: {
    StringFilter,
  },
})
export default class EditableFormatSummaryDirectoryFilter extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryDirectoryFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryDirectoryFilterParameter) => void) => void;

  get name(): StringFilterParameter {
    return this.readPropertyOrDefault(s => s.name, null);
  }

  set name(source: StringFilterParameter) {
    this.writeProperty(s => s.name = source);
  }
}
